export enum CurrencyEnum {
  KWD = "KWD", // Kuwait
  SAR = "SAR", // KSA
  AED = "AED", // UAE
  BHD = "BHD", // Bahrain
  QAR = "QAR", // Qatar
  OMR = "OMR", // Oman
  EGP = "EGP", // Egypt
  USD = "USD",
}
